module.exports = __webpack_public_path__ + "img/sharePoster.56b1f878.png";